import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/7745b583fbee9ccea8c8cf76b9888a03.jpg"
          alt="Levadas da Madeira"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-blue/90 via-navy-blue/70 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-light text-white mb-6">
            Pronto para a Sua <span className="font-serif italic">Aventura</span>?
          </h2>
          <p className="text-white/90 text-lg md:text-xl leading-relaxed mb-8">
            Reserve agora e garanta as melhores tarifas. Cancelamento flexível e 
            confirmação imediata por e-mail.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Link
              to="/apartamentos"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-navy-blue rounded-full font-semibold text-base hover:bg-sand-beige transition-all whitespace-nowrap cursor-pointer group"
            >
              Ver Disponibilidade
              <i className="ri-calendar-check-line ml-2 text-xl group-hover:scale-110 transition-transform"></i>
            </Link>
            
            <Link
              to="/contactos"
              className="inline-flex items-center justify-center px-8 py-4 bg-transparent text-white rounded-full font-semibold text-base hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer border-2 border-white"
            >
              Falar Connosco
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-8">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <div>
                <p className="text-white font-semibold">Reserva Segura</p>
                <p className="text-white/70 text-sm">Pagamento protegido</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <div>
                <p className="text-white font-semibold">Confirmação Imediata</p>
                <p className="text-white/70 text-sm">Resposta em minutos</p>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                <i className="ri-customer-service-2-line text-white text-2xl"></i>
              </div>
              <div>
                <p className="text-white font-semibold">Suporte 24/7</p>
                <p className="text-white/70 text-sm">Sempre disponível</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;